import { configureStore } from "@reduxjs/toolkit";
import userAuthSlice from "./slices/userAuthSlice";
import userInfoSlice from "./slices/userInfoSlice";
import userFeedSlice from "./slices/userFeedSlice";
import SuggNotificationSlice from "./slices/Sugg&NotificationSlice";
import campaignSlice from "./slices/campaignSlice";

import followerFollowingSlice from "./slices/followerFollowingSlice";
import profileDataSlice from "./slices/profileDataSlice";
import walletSlice from "./slices/walletSlice";
import nftSlice from "./slices/nftSlice";
import rewardSlice from "./slices/rewardSlice";
import loginDialogSlice from "./slices/loginDialogSlice";

const store = configureStore({
  reducer: {
    userAuth: userAuthSlice,
    userInfo: userInfoSlice,
    userFeed: userFeedSlice,
    userSuggestionAndNotifications: SuggNotificationSlice,
    campaigns: campaignSlice,
    followersFollowingData: followerFollowingSlice,
    profileData: profileDataSlice,
    walletData: walletSlice,
    nftMarketPlaceData: nftSlice,
    userRewards: rewardSlice,
    loginDialogState: loginDialogSlice,
  },
  // devTools: false,
});

export default store;
